import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionTopContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  height: ${72 * Screen.widthRatio}px;
  margin-top: ${40 * Screen.widthRatio}px;
  position: relative;
`;

export default DescriptionTopContainer;
